<template>
  <q-banner class="bg-grey-2 rounded-borders">
    <slot v-bind="{ total, isLoading }">
      This report will contain <strong v-show="!isLoading">{{ total }}</strong>
    </slot>
    <q-icon v-show="isLoading" name="fa fa-circle-notch fa-spin"/> {{ postsText }}.
  </q-banner>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { PostFilters } from '@/type';
import { HasTaskMixin } from '@/mixins';
import repository from '@/social/post/post-repository';

interface Data {
  total: number,
  task: Promise<number>|null
}

export default defineComponent({
  mixins: [HasTaskMixin],
  props: {
    filters: {
      type: Object as () => PostFilters,
      required: true,
    },
  },
  data(): Data {
    return {
      total: 0,
      task: null,
    };
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.count();
      },
    },
  },
  computed: {
    postsText(): string {
      return (this.total === 1) ? 'post' : 'posts';
    },
  },
  methods: {
    count() {
      this.task = repository.count(this.filters);
      this.task.then((total: number) => {
        this.total = total;
      });
    },
  },
});
</script>
